import { UserAccessRestrictionCode, UserAccessRestrictionQueryParams } from "../types"
import { userSessionStore } from "../model"
import { hasAccessTo } from "~/domain/user-session/api/hasAccessTo"

export async function getUserAccessRestrictionStatus({
														 objects,
														 secureOp,
														 ignoreNotChangedPassword
													 }: UserAccessRestrictionQueryParams = {}) {
	let code = UserAccessRestrictionCode.ACCESS_IS_ALLOWED
	let objectIndex: number | undefined

	const accessToObjectsRequired = objects !== undefined
	const userInfo = userSessionStore.userInfo

	if (!userInfo) {
		code = UserAccessRestrictionCode.LOGIN_IS_REQUIRED
	} else if (!ignoreNotChangedPassword && userInfo.blocked === 2) {
		code = UserAccessRestrictionCode.PASSWORD_CHANGE_IS_REQUIRED
	} else if (accessToObjectsRequired) {
		const access = await hasAccessTo(objects, secureOp)

		if (access !== true) {
			code = UserAccessRestrictionCode.NO_ACCESS

			if (access !== false) {
				objectIndex = access
			}
		}
	}

	return { code, objectIndex }
}